"use strict";
exports.__esModule = true;
exports.INCOME_VERIFICATION_UPLOAD_PAYSTUBS = void 0;
exports.INCOME_VERIFICATION_UPLOAD_PAYSTUBS = {
    HEADER: 'Upload paystubs',
    BODY: 'We’ll use Plaid to collect and verify your paystubs.',
    REQUIREMENTS_HEADER: 'Document requirements',
    REQUIREMENTS_BULLETS: [
        'Includes your name, employer name, pay period, and total amount paid',
        'Pay date of {{pastThirtyDaysDate}} or after',
        'No W-2 forms or employment verification letters',
        'Not password protected',
        'PDF files preferred',
    ],
    CALLOUT: {
        HEADER: 'Processing may take 3 business days',
        BODY: 'To speed up the process, ',
        BODY_BOLD: 'connect your bank account.'
    },
    DISCLAIMER: {
        HEADER: 'Flex service may not begin until {{nextBpMonth}}',
        BODY: 'Verifying with paystubs often requires additional processing time. To speed up the process, ',
        BODY_BOLD: 'connect your bank account.'
    },
    CTA: 'Continue to upload'
};
